import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai'
import { InputContainer } from '../../pages/signup'
import { Button } from '../../components/button'
import { colors } from "../../colors";
import { FaAngleDown } from "react-icons/fa";


const Accordion = ({ heading, accordingContentFor, func, active, content }) => {
    
    const [activeAccordion, setActiveAccordion] = useState(true);
    return (

    <AccordionContainer>

        <AccordionHeading onClick={(e) => { setActiveAccordion(!activeAccordion) }  }>
            <p>Use search filter</p>
            <span >+</span>
            
        </AccordionHeading>

{
    !activeAccordion ?

    
        <AccordionContent>
            <h3>Enter search criteria</h3>

            <form>
                <MainInputContainer>
                    <InputContainer>
                        <label htmlFor="resourceType">Resource Type</label>
                        <select name="resourceType" id="resourceType">
                            <option value="nigeriana">Nigeriana</option>
                            <option value="external">External Resources</option>
                        </select>
                    </InputContainer>

                    <InputContainer>
                        <label htmlFor="nigerianaCategory">Category</label>
                        <select name="nigerianaCategory" id="nigerianaCategory">
                            <option value="">Select Category</option>
                            <option value="annualReports">Annual Reports</option>
                            <option value="commissionOfEnquiries">Commission of Enquiries</option>
                            <option value="budgets">Budgets</option>
                            <option value="nationalAssemblyReports">National Assembly Reports</option>
                            <option value="otherPublications">Other Publications</option>
                            <option value="researchReports">Research Reports</option>
                            <option value="conferenceProceedings">Conference Proceedings</option>
                        </select>
                    </InputContainer>

                </MainInputContainer>

                <MainInputContainer>

                    <InputContainer>
                        <label htmlFor="title">Title</label>
                        <input name="title" id="title" type="search" />
                    </InputContainer>

                    <InputContainer>
                        <label htmlFor="author">Author</label>
                        <input name="author" id="author" type="search" />
                    </InputContainer>
                </MainInputContainer>

                <MainInputContainer>
                    <InputContainer>
                        <label htmlFor="tag">Keyword/tag</label>
                        <input name="tag" id="tag" type="search" />
                    </InputContainer>

                    <InputContainer>
                        <label htmlFor="category">Year Published</label>
                        <input name="category" id="category" type="search" />
                    </InputContainer>
                </MainInputContainer>


                {/* <MainInputContainer>
                    <InputContainer>
                        <label htmlFor="date">From</label>
                        <input name="date" id="date" type="search" placeholder="Year" />
                    </InputContainer>

                    <InputContainer>
                        <label htmlFor="toYear">To</label>
                        <input name="toYear" id="toYear" type="search" placeholder="Year" />
                    </InputContainer>
                </MainInputContainer> */}


                <MainInputContainer>
                    <InputContainer>
                        <label htmlFor="pubafter">Publisher</label>
                        <input name="pubafter" id="pubafter" type="search" />
                    </InputContainer>

                    <InputContainer>
                        <label htmlFor="nln">NLN Code</label>
                        <input name="nln" id="nln" type="search" />
                    </InputContainer>
                </MainInputContainer>
                <br />
                <hr />
                <br />
                {/* <h3>Sort by</h3>
                <MainInputContainer>
                    <select name="" id="">
                        Date Published
                    <option value="">2022</option>    
                    </select>
                </MainInputContainer> */}

                <ButtonContainer>
                    <Button filled bgColor='#2A870E' noIcon text={'Submit all selections'} />
                    <Button bgColor='#2A870E' noIcon text={'Clear selections'} />

                    
                </ButtonContainer>

            </form>
            
        </AccordionContent>

: null
}

    </AccordionContainer>
  )}

  const AccordionContainer = styled.div`
    overflow: hidden;
    width: 100%;
    border-radius: 5px;
    
  `

  const AccordionHeading = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px 25px;
    border-top: 2px solid ${colors.primary};
    border-bottom: 2px solid ${colors.primary};
    /* background-color: {!activeAccordion ? '#2A870E' : '#fff'}; */
    background-color: #EAECF0;
    position: relative;
    /* height: ${props=> {
            const inner = document.getElementById(props.itemName);
            return `${props.isActive && inner ? inner.clientHeight : 0}px`
        } };
        transition: height 0.35s; */

    & > p{
        font-weight: 600;
    }

    & > span{
        font-size: 25px;
        font-weight: 600;
        cursor: 'pointer'; 
        transform: rotate(${props => props.isActive ? -180 : 0 }); 
        transition: all 0.2s;
        cursor: pointer;
    }
  `

    const AccordionContent = styled.div`
        /* display: ${props => props.active ? 'block' : 'none'}; */
        position: relative;
        display: flex;
        flex-direction: column;
        /* height: ${props => props.active ? 'auto' : '0px'}; */
        
        padding: 15px 25px 35px 25px;
        background-color: ${colors.white};
        border: 1px solid #D0D5DD;
        margin-bottom: 40px;
    `

    const MainInputContainer = styled.div`
        
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;

        & > div{
            width: 47%;

            & h5{
                font-weight: 400;
            }
            &  input{
                /* width: 207%; */
            }
        }

       
    `

    const ButtonContainer = styled.div`

        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;

    
    & Button{
            width: 100%;
            height: 30px;
            margin-top: 20px;
            width: 47%;
        }
    `
export { Accordion };

